import styled from "styled-components";

export const StyledFilterWrapper = styled.div`
  ${({ pt }) => pt && `padding-top: ${pt}px`};
  ${({ pb }) => pb && `padding-bottom: ${pb}px`};
  display: grid;
  grid-template-columns: 175px;
  grid-template-rows: 45px;
  grid-gap: 30px;
  align-items: center;
  /*.filter-search {
    &__text {
      & > div {
        input {
          background: ${({theme}) => theme.surface.subtle} !important;
        }
      }
    }
    @media screen and (max-width: 599px) {
      display: none;
    }
  }*/
  .rc-dropdown {
    z-index: 1200;
  }
  button {
    height: 100%;
  }
`;

export const StyledShowFilterBtn = styled.div`
  width: 100%;
  height: 100%;
  button {
    width: 100%;
    height: 100%;
    color: ${({theme}) => theme.filter.submitColor};
    font-size: 14px;
    font-weight: 600;
    background: ${({theme}) => theme.filter.submitBackground};
    border: 0px;
  }
`;

export const StyledFilterGroup = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  label {
    color: ${({theme}) => theme.input.labelColor};
    font-size: 14px;
    transform: translate(0, 1.5px) scale(0.75);
    transform-origin: top left;
  }
  input {
    padding: 5px 0 7px;
    color: ${({theme}) => theme.input.color};
    border: none;
    background-color: transparent;
    border-bottom: 1px solid ${({theme}) => theme.overlay.underline};
    &:hover {
      border-bottom: 1px solid ${({theme}) => theme.overlay.underlineHover};
      box-shadow: 0 1px 0 0 ${({theme}) => theme.overlay.underlineHover};
    }
    &:focus {
      border-bottom: 1px solid ${({theme}) => theme.input.focusUnderline};
    }

    &::-webkit-input-placeholder {
      opacity: 0.35;
    }
    &:-moz-placeholder {
      opacity: 0.35;
    }
    &::-moz-placeholder {
      opacity: 0.35;
    }
    &:-ms-input-placeholder {
      opacity: 0.35;
    }
  }
`;

export const StyledSelectGroup = styled.div`
  height: 46px;
  width: 100%;
  display: grid;
`;

export const StyledItemsPerPage = styled.div`
  max-width: 175px;
  width: 100%;
  display: grid;
  background-color: ${({theme}) => theme.filter.itemsPerPageBackground};
  label {
    padding: 1px 5px;
    background-color: ${({theme}) => theme.filter.itemsPerPageBackground};
  }
  // MUI рахує висоту outlined-селекта з падінгу і метрик шрифта — задаємо явно, щоб збігалась з кнопкою
  .MuiOutlinedInput-root {
    height: 45px;
  }
  .MuiOutlinedInput-input {
    padding: 0 14px;
  }
  .MuiSelect-select:focus {
    background-color: transparent;
  }
`;

export const StyledFilterDropdownWrapper = styled.div`
  min-width: 295px;
  max-width: 840px;
  width: 100%;
  margin-top: 10px;
  padding: 15px;
  background-color: ${({theme}) => theme.filter.dropdownBackground};
  box-shadow: ${({theme}) => theme.filter.dropdownShadow};
  border-radius: 4px;
  overflow-y: auto;
  .clear-btn {
    min-height: 42px;
    button {
      padding: 0 15px;
    }
  }
  .close-btn {
    display: inline-flex;
    justify-content: flex-end;
  }

  @media screen and (max-width: 768px) {
    padding: 10px;
  }
`;

export const StyledFilterBlockTitle = styled.div`
  ${({ mt }) => mt && `margin-top: ${mt}px`};
  margin-bottom: ${({mb}) => mb || 5}px;
  color: ${({theme}) => theme.filter.titleColor};
  font-size: 14px;
  font-weight: 700;
`;

export const StyledFilterBlock = styled.div`
  padding: 15px;
  display: grid;
  grid-template-columns: ${({ actions, col }) => actions ? `max-content max-content !important` : `repeat(${col ?? 3}, minmax(0, 260px))`};
  ${({ actions }) => actions && `justify-content: space-between`};
  grid-gap: 15px;
  background-color: ${({ actions, theme }) => actions ? "transparent" : theme.filter.blockBackground};
  input {
    padding: 3px 0;
  }
  &:not(&:last-child) {
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${({theme}) => theme.overlay.divider};
  }

  @media screen and (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 768px) {
    padding: 10px;
    grid-template-columns: 100%;
  }
`;

export const StyledFilterList = styled.div`
  padding-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media screen and (max-width: 768px) {
    width: 100%;
    flex-wrap: nowrap;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const StyledFilterListItem = styled.div`
  max-width: 250px;
  padding: 5px 10px;
  color: ${({theme}) => theme.filter.chipColor};
  font-family: inherit;
  font-size: 12px;
  line-height: 16px;
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: 1px solid ${({ clearAll, theme }) => clearAll ? theme.filter.clearColor : theme.filter.chipBorder};
  border-radius: 5px;
  outline: none;
  transition: all .3s ease;
  white-space: nowrap;
  cursor: ${({ clearAll }) => clearAll ? "pointer" : "default"};

  &:hover {
    background-color: ${({ clearAll, theme }) => clearAll ? theme.filter.clearHoverBackground : theme.filter.chipHoverBackground};
  }

  .key,
  .value {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .key {
    font-weight: 600;
  }

  .value {
    padding-left: 4px;
  }

  .remove {
    padding-left: 8px;
    color: ${({theme}) => theme.filter.clearColor};
    font-size: 8px;
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }
`;

export const StyledFilterCloseBtn = styled.button`
  position: relative;
  height: 30px !important;
  width: 30px !important;
  padding: 0 !important;
  border: none;
  border-radius: 50%;
  transition: all .3s ease;
  &:before {
    content: '\\e900';
    color: ${({theme}) => theme.filter.closeColor};
    font-family: 'cp-icons', serif;
  }
  &:hover {
    background-color: ${({theme}) => theme.overlay.hover};
  }
`;